export { ContactItem } from './ContactItem'
export type { ContactItemProps } from './ContactItem.types'
